import { useEffect, useState } from "react";
import { apiCallV2 } from "../../../utils/api";
import { getAge } from "../../../utils/date";
import { RiLoader4Line } from "react-icons/ri";
import useSVG from "../../../hooks/useSVG";
import { programLevels, weeks } from "../../../constants";
import CustomTableV2 from "../../../common/CustomTableV2";

function UserDetails(props) {
    const { UseGoal, UseProgramSVG } = useSVG();
    const { goals, programs } = props;
    const [accountDetails, setAccountDetails] = useState({});
    const genders = {
        Male: "MALE",
        Female: "FEMALE",
        M: "MALE",
        F: "FEMALE",
        GNL: "GENDER NOT LISTED",
        PNTS: "PREFER NOT TO SAY",
        O: "OTHERS",
    }

    const getGoals = (pGoals) => {
        let uGoals = [];
        for (let x = 0; x < goals.length; x++) {
            if (pGoals?.includes(goals[x]?.id)) {
                uGoals.push(goals[x]);
            }
        }
        return uGoals?.length ? uGoals : null;
    }

    const getPrograms = (pPrograms) => {
        let uPrograms = [];
        for (let x = 0; x < pPrograms?.length; x++) {
            uPrograms.push({ ...programs.find(p => p?.id == pPrograms[x]?.program_id), ...pPrograms[x] });
        }
        return uPrograms?.length ? uPrograms : null;
    }

    useEffect(() => {
        const cb = async () => {
            setAccountDetails({});
            const res = await apiCallV2("GET", "admin/load-user-details", "", localStorage.getItem("access-token"), {
                userID: props?.user?.id,
            }, false);
            setAccountDetails(res?.data?.data || {});
        }
        cb();
    }, [props?.user?.id]);

    let onboardingDetails = accountDetails?.onboardingDetails?.[0] || {};


    let uGoals = getGoals(onboardingDetails?.goals ? JSON.parse(onboardingDetails?.goals) : []);
    let uPrograms = getPrograms(accountDetails?.selectedPrograms);
    let aiSchedule = onboardingDetails?.schedule ? JSON.parse(onboardingDetails?.schedule) : null;


    return (
        <div id="user-details" className="row">

            <div className="col-md-4">
                <div id="ud-personal" className="ud-content">
                    <div className="row">
                        <div className="udc-name col-md-12">
                            <h4>{`${props?.user?.last_name}, ${props?.user?.first_name}`}</h4>
                        </div>
                        <div className="udc-email col-md-12">
                            <em>{props?.user?.email_address}</em>
                        </div>
                        <div className="udc-age-gen col-md-12 row">
                            <div className="col-md-6">
                                <h5>{genders[props?.user?.gender]}</h5>
                                <span>Gender</span>
                            </div>
                            <div className="col-md-6">
                                <h5>{`${getAge(props?.user?.dob)}`}</h5>
                                <span>Age</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="col-md-8">
                <div className="row">
                    <div className="col-md-12">
                        <div id="ud-goals" className="ud-content">


                            {!uGoals && <div className="ud-c-loader"> Loading Goals...<RiLoader4Line className="custom-loader-icon rotate" /></div>}
                            {
                                uGoals && <>
                                    <h5>Goals</h5>
                                    <div className="row">
                                        {
                                            uGoals?.map((goal, i) => {
                                                return (
                                                    <div key={i} className="udc-goals col-md-4">
                                                        {UseGoal(goal?.svg)}
                                                        <h6>{goal?.title}</h6>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div id="ud-programs" className="ud-content">
                            {!uPrograms && <div className="ud-c-loader"> Loading Programs...<RiLoader4Line className="custom-loader-icon rotate" /></div>}
                            {uPrograms && <>
                                <h5>Programs</h5>
                                <div className="row">
                                    {
                                        uPrograms?.map((program, i) => {
                                            return (
                                                <div key={i} className="udc-programs col-md-4">
                                                    <div className="udcp-svg">
                                                        {UseProgramSVG(program?.svg)}
                                                        {UseProgramSVG(`${programLevels[program?.level].toLowerCase()}${program?.svg}`)}
                                                    </div>
                                                    <h6>{`${program?.title}${" - " + programLevels[program?.level]}`}</h6>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>}
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div id="ud-onb-survey" className="ud-content">
                            <h5>Onboarding Survey</h5>
                            <div className="ud-c-form">

                                {!onboardingDetails?.preferred_days && <div className="ud-c-loader"> Loading Onboarding Info...<RiLoader4Line className="custom-loader-icon rotate" /></div>}
                                {onboardingDetails?.preferred_days && <div className="row">
                                    <div className="col-md-6">
                                        <h6>Preferred days to workout: </h6>
                                        <h6>{onboardingDetails?.preferred_days && JSON.parse(onboardingDetails?.preferred_days)?.join(", ")}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Current workout length per week: </h6>
                                        <h6>{onboardingDetails?.preferred_min_per_week}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Consistency: </h6>
                                        <h6>{onboardingDetails?.consistency}</h6>
                                    </div>
                                    <div className="col-md-6">
                                        <h6>Preferred workout length: </h6>
                                        <h6>{onboardingDetails?.preferred_workout_length}</h6>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div id="ud-onb-survey" className="ud-content">
                            <h5>AI Suggested Schedule</h5>

                            {!aiSchedule && <div className="ud-c-loader"> Loading Schedule...<RiLoader4Line className="custom-loader-icon rotate" /></div>}
                            {aiSchedule?.length && <div>
                                {
                                    aiSchedule && aiSchedule?.map(fr => {
                                        return (
                                            <div className="opp-c-c-b-final-result">
                                                <CustomTableV2
                                                    title={`Week ${fr?.weekNo}`}
                                                    description=""
                                                    store={{
                                                        list: fr?.days,
                                                        count: fr?.days?.length,
                                                    }}
                                                    table={{
                                                        headers: [

                                                            { title: "Day" },
                                                            { title: "Program" },
                                                            { title: "Duration" },
                                                        ],
                                                        body: (data, i) => {
                                                            let rps = [...data?.recommendedPrograms];

                                                            rps.shift();

                                                            // if (rps?.length > 1) {
                                                            // }

                                                            return (
                                                                <>
                                                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                                        <td><h5>{weeks[(data?.day * 1) + 1]}</h5></td>
                                                                        <td><h5>{data?.recommendedPrograms[0]?.program}</h5></td>
                                                                        <td><h5>{data?.recommendedPrograms[0]?.min}</h5></td>
                                                                    </tr>
                                                                    {
                                                                        rps?.map((rp, i2) => {
                                                                            return (
                                                                                <tr className={(i + i2) % 2 == 0 ? "tr-even" : ""}>
                                                                                    <td><h5></h5></td>
                                                                                    <td><h5>{rp?.program}</h5></td>
                                                                                    <td><h5>{rp?.min}</h5></td>
                                                                                </tr>
                                                                            )
                                                                        })

                                                                    }

                                                                </>
                                                            )
                                                        }
                                                    }}
                                                    actions={{
                                                    }}
                                                    withPagination={false}
                                                    withSearch={false}
                                                    defaultPerPage={100}
                                                />
                                            </div>

                                        )
                                    })
                                }
                            </div>}
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default UserDetails;